/* eslint-disable no-shadow */
import PropTypes from 'prop-types';

import React from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import Icon from '@starbucks-web/pattern-library/lib/components/icon';
import circularArrowPath from '@starbucks-web/pattern-library/lib/icons/circular-arrow';

import {
  expectingBalanceResponseSelector,
  getSvcCardBalance as getCardBalance,
} from 'shared/app/bundles/svc-cards';

import styles from './styles.cssm';

const messages = defineMessages({
  refreshBalanceButtonLabel: {
    id: 'accountCards.refreshBalanceButton.refreshBalance',
    defaultMessage: 'Refresh balance',
    description:
      'Accessible label for refreshing balance on a Stored Value Card',
  },
});

const RefreshBalanceButton = ({
  card,
  className,
  expectingBalanceResponse,
  getCardBalance,
  intl,
  ...otherProps
}) => {
  const { formatMessage } = intl;
  const { cardId } = card;
  const rotateClass = expectingBalanceResponse ? styles.rotateArrow : '';

  return (
    <button
      aria-label={formatMessage(messages.refreshBalanceButtonLabel)}
      className={`color-textBlackSoft position-relative ${styles.base} ${rotateClass} ${
        className || ''
      }`}
      data-e2e="refreshBalance"
      onClick={() => {
        getCardBalance(cardId);
      }}
      {...otherProps}
    >
      <Icon path={circularArrowPath} />
    </button>
  );
};

RefreshBalanceButton.propTypes = {
  card: PropTypes.object,
  getCardBalance: PropTypes.func,
  expectingBalanceResponse: PropTypes.bool,
};

const select = (state) => ({
  expectingBalanceResponse: expectingBalanceResponseSelector(state),
});

const actions = { getCardBalance };

export default injectIntl(connect(select, actions)(RefreshBalanceButton));
